import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 *
 * You can be released from the terms, and requirements of the Academic Public
 * License by purchasing a commercial license.
 * Purchase of a commercial license is mandatory for any use of the
 * LMX Software in commercial settings.
 */
// END COPYRIGHT
import Box from "@mui/material/Box";
import { keyframes, styled } from "@mui/material/styles";
import { landingPalette } from "../theme";
// #region: Styled Components
// Keyframes lead the region; the styled components below reference them.
const pulse = keyframes `
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;
const spin = keyframes `
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const FixedLoaderOverlay = styled(Box)(() => ({
    position: "fixed",
    top: 20,
    right: 20,
    zIndex: 9999,
    // A lighter step up from the navbar, so the panel reads as raised rather than lost in the dark blue.
    background: landingPalette.buttonHover,
    border: "1px solid rgba(255, 255, 255, 0.18)",
    backdropFilter: "blur(10px)",
    borderRadius: 12,
    padding: "16px 24px",
    boxShadow: landingPalette.buttonHoverShadow,
    display: "flex",
    alignItems: "center",
    gap: 12,
    animation: `${pulse} 2s ease-in-out infinite`,
}));
const LoadingText = styled("span")(({ theme }) => ({
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: "0.5px",
}));
const Spinner = styled(Box)(() => ({
    border: "3px solid rgba(255, 255, 255, 0.25)",
    borderTop: `3px solid ${landingPalette.accent}`,
    borderRadius: "50%",
    width: 24,
    height: 24,
    animation: `${spin} 0.8s linear infinite`,
}));
// #endregion: Styled Components
const LoadingSpinner = () => {
    return (_jsxs(FixedLoaderOverlay, { "data-testid": "loading_spinner-overlay-div", "aria-label": "Loading indicator", "aria-live": "polite", role: "status", children: [_jsx(Spinner, {}), _jsx(LoadingText, { children: "Loading..." })] }));
};
export default LoadingSpinner;
